import { useSelector } from 'react-redux'
import { useState } from 'react'
import { functional } from '@think-internet/zeus-frontend-package'
import { useParams } from 'react-router-dom'
import props from '../../../../redux/props'
import { Offer, Type } from '../../../../types/Controlling/Offer'
import Button from '../../../UI/Button/Button'
import Modal from '../../../UI/Modal/Modal'
import DirectFileUpload, { OnCallbackFile, UPLOAD_TYPES } from '../../../UI/DirectFileUpload/DirectFileUpload'
import { fileMaxFileSizeInBytes, fileMimeTypes } from '../../../../utility'
import Entries from './Entries/Entries'
import { OfferEntry } from '../../../../types/Controlling/OfferEntry'
import Routes from '../../../../redux/routes'
import useToast from '../../../hooks/useToast'

type Props = {
  callback: () => void
}

const AddOffer: React.FC<Props> = ({ callback }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [show, setShow] = useState(false)
  const { companyUUID } = useParams()
  const [data, setData] = useState<Offer>({ companyUUID, type: Type.INCOME, entryUUIDList: [], entries: [] })
  const createOffer = functional.use(Routes.CONTROLLING_OFFER_CREATE)
  const toast = useToast()

  const toggle = () => setShow(!show)

  const save = async () => {
    const offer = await createOffer({ offer: data })
    if (offer) {
      callback()
      toggle()
      setData({ companyUUID, type: Type.INCOME, entryUUIDList: [], entries: [] })
    } else {
      toast(t.controlling.offer.add.error)
    }
  }

  const selectType = (type: Type) => () => setData({ ...data, type })

  const isConfirmEnabled = () => Array.isArray(data.entries)

  const onFile = (file: OnCallbackFile) => setData({ ...data, fileKey: file.key, fileName: file.name })

  const updateEntries = (entries: OfferEntry[]) => {
    const entryUUIDList = entries.map((e) => e.uuid)
    setData({ ...data, entryUUIDList, entries })
  }

  return (
    <div className="flex gap-3">
      <Button onClick={toggle} text={t.controlling.offer.add.cta} />
      <Modal noForm show={show} onClose={toggle} onConfirm={isConfirmEnabled() && save} title={t.controlling.offer.add.title}>
        <div className="flex flex-col gap-3">
          <div className="flex gap-3 mt-3">
            {Object.keys(Type).map((type) => (
              <div
                key={type}
                onClick={selectType(type as Type)}
                className={`py-1 px-3 flex-1 text-center cursor-pointer ${
                  data.type === type ? 'bg-blue text-white border border-blue' : 'bg-white border border-blue text-blue'
                }`}
              >
                {t.controlling.offer.type[type]}
              </div>
            ))}
          </div>
          {!!data.type && (
            <>
              <div className="flex gap-2 flex-col">
                <DirectFileUpload
                  uploadType={UPLOAD_TYPES.CONTROLLING_OFFER_FILE}
                  allowedMimeTypes={fileMimeTypes}
                  maxFileSizeInBytes={fileMaxFileSizeInBytes}
                  onFilesCallback={onFile}
                  label={t.controlling.offer.fileUploadLabel}
                />
                {data.fileName && <div className="text-sm">{data.fileName}</div>}
              </div>
            </>
          )}
          {!!data.fileKey && <Entries entries={data.entries} onChange={updateEntries} />}
        </div>
      </Modal>
    </div>
  )
}

export default AddOffer
